/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function ($) {
  // var $win = $(window);
  const $win = $(window);
  const $doc = $(document);

  $('.send-email').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('clicked');
    $('.quote-form').show();
  });

  var $quoteForm = $('.quote-form form');
  var quoteFormFlag = false;

  $quoteForm.on('submit', function (e) {
    if (!quoteFormFlag) {
      e.preventDefault();

      $('.Product .ProductForm__OptionName').each((index, element) => {
        var optionName = element.dataset.title;
        var optionValue = $(element).find('.ProductForm__SelectedValue').text();
        var inputMarkup = '<input type="hidden" name="contact[' + optionName + ']" value="' + optionValue + '" />';

        console.log(inputMarkup);

        $quoteForm.append(inputMarkup);
      });

      quoteFormFlag = true;
      
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead');
        }
      } catch (trackingError) {} 
      
      $(this).submit();
    }
  });
})(jQuery);
